<template>
    <div :style="{right:position}" class="scrollTop">
        <img src="./next-round.svg"/>
    </div>
</template>
<style src="./scrollTop.css">
</style>
<script src="./scrollTop.js">
</script>
